import { MutationTree } from 'vuex';
import { SystemState } from '@/store/modules/system/index';
import { SystemLogin } from '@/models/system/SystemLogin';
import {
  SET_CREDENTIALS,
  SET_FORMS_FILTERS,
  SET_LOGIN_PENDING,
  SET_OPEN_TERMS_AND_PRIVACY,
  SET_PROCESS_COMPARE_REQUEST,
  SET_PROCESS_COMPARE_REQUESTS_ERRORS,
  SET_PROCESS_COMPARE_REQUESTS_LOADING,
  SET_QUARTZ_INFO,
  SET_RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS,
  SET_RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS,
  SET_RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS,
  SET_SYSTEM_CACHE_LIST,
  SET_SYSTEM_ERRORS,
  SET_SYSTEM_JOB_LOG,
  SET_SYSTEM_JOBS_ERRORS,
  SET_SYSTEM_JOBS_LOGS_LIST,
  SET_SYSTEM_QUARTZ_ERRORS,
  SET_SYSTEM_STATISTICS_ERRORS,
  SET_TEST_MAILS_ERRORS,
  SET_TOKEN,
} from '@/types/system.types';
import { QuartzInfo } from '@/models/system/QuartzInfo';
import { FormsFiltersModel } from '@/models/system/FormsFilters';
import { ProcessCompareRequest } from '@/models/system/process-compare-request';

export const mutations: MutationTree<SystemState> = {

  [SET_CREDENTIALS]: (state, credentials: SystemLogin) => {
    state.credentials = credentials;
  },

  [SET_TOKEN]: (state, token: string) => {
    state.token = token;
  },

  [SET_SYSTEM_ERRORS]: (state, systemErrors: string[]) => {
    state.systemErrors = systemErrors;
  },

  [SET_SYSTEM_QUARTZ_ERRORS]: (state, systemQuartzErrors: string[]) => {
    state.systemQuartzErrors = systemQuartzErrors;
  },

  [SET_SYSTEM_JOBS_ERRORS]: (state, systemJobsErrors: string[]) => {
    state.systemJobsErrors = systemJobsErrors;
  },

  [SET_SYSTEM_STATISTICS_ERRORS]: (state, systemStatisticsErrors: string[]) => {
    state.systemStatisticsErrors = systemStatisticsErrors;
  },

  [SET_LOGIN_PENDING]: (state, loginPending: boolean) => {
    state.loginPending = loginPending;
  },

  [SET_SYSTEM_CACHE_LIST]: (state, systemCacheList: string[]) => {
    state.systemCacheList = systemCacheList;
  },

  [SET_SYSTEM_JOBS_LOGS_LIST]: (state, systemJobsLogsList: string[]) => {
    state.systemJobsLogsList = systemJobsLogsList;
  },

  [SET_SYSTEM_JOB_LOG]: (state, systemJobLog: string[]) => {
    state.systemJobLog = systemJobLog;
  },

  [SET_QUARTZ_INFO]: (state, quartzInfo: QuartzInfo) => {
    state.quartzInfo = quartzInfo;
  },

  [SET_FORMS_FILTERS]: (state, formsFilters: FormsFiltersModel) => {
    state.formsFilters = formsFilters;
  },

  [SET_RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS]: (state, runForm101PdfGeneratorJobErrors: string[]) => {
    state.runForm101PdfGeneratorJobErrors = runForm101PdfGeneratorJobErrors;
  },

  [SET_RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS]: (state, runForm101PdfFilesExportJobErrors: string[]) => {
    state.runForm101PdfFilesExportJobErrors = runForm101PdfFilesExportJobErrors;
  },

  [SET_RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS]: (state, runForm101PdfComsignJobErrors: string[]) => {
    state.runForm101PdfComsignJobErrors = runForm101PdfComsignJobErrors;
  },

  [SET_TEST_MAILS_ERRORS]: (state, testMailsErrors: string[]) => {
    state.testMailsErrors = testMailsErrors;
  },

  [SET_PROCESS_COMPARE_REQUEST]: (state, processCompareRequest: ProcessCompareRequest) => {
    state.processCompareRequest = { ...state.processCompareRequest, ...processCompareRequest };
  },

  [SET_PROCESS_COMPARE_REQUESTS_ERRORS]: (state, processCompareRequestsErrors: string[]) => {
    state.processCompareRequestsErrors = processCompareRequestsErrors;
  },

  [SET_PROCESS_COMPARE_REQUESTS_LOADING]: (state, processCompareRequestsLoading: boolean) => {
    state.processCompareRequestsLoading = processCompareRequestsLoading;
  },

  [SET_OPEN_TERMS_AND_PRIVACY]: (state, openTermsAndPrivacyModal: boolean) => {
    state.openTermsAndPrivacyModal = openTermsAndPrivacyModal;
  },

};
